import React, {Component, PureComponent} from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import {Server, ModalHelper, AlertModal, helper}  from "./../app.js"; 

export default class TrayCoverSelecter extends PureComponent 
{
    quantity = 0;
    prevTrayLength = 0;
    modal = null;

    constructor (props)
    {
        super(props);

        const hasCover = !helper.isNotObjectOrEmpty(this.props.init_cover);

        this.state = {
            covers: {},
            id: hasCover ? this.props.init_cover.id : '', 
            length: 0,
            loading: false,
            alert_message: ''
        };

        this.quantity = hasCover ? this.props.init_cover.quantity : 0; // this.props.tray_quantity
        this.prevTrayLength = this.getTrayLength();
        this.state.length = hasCover ? this.quantity * this.props.init_cover.length : 0; // this.prevTrayLength

        //console.log('constructor this.quantity', this.quantity);

        this.modal = new ModalHelper(this);

        this.hasTray = this.hasTray.bind(this);
        this.markNeedCover = this.markNeedCover.bind(this);
        this.setLength = this.setLength.bind(this);
        this.roundLength = this.roundLength.bind(this);  
        this.modal.showProjectChangeWarning = this.modal.showProjectChangeWarning.bind(this.modal); 
    }
    get cover ()
    {
        const id = this.state.id;
        let cover = null;

        if (id && id in this.state.covers)
        {
            cover = this.state.covers[id];
        }
        return cover;
    }
    hasTray ()
    {
        return this.props.tray_quantity > 0;
    }
    getTrayLength ()
    {
        return this.props.tray_length * this.props.tray_quantity;
    }
    loadCovers ()
    {
        if (this.hasTray())
        {   
            this.setState({loading: true});

            Server.instance
                .query('get_tray_covers', 
                {
                    tray_articul: this.props.tray_articul,
                    tray_width: this.props.tray_width
                })
                .then((recievedCovers) =>
                {
                    helper.setStateWithRecievedItems(this, 'covers', recievedCovers);
                })
                .catch(() => this.setState({covers: {}, loading: false}));
        }
    }
    markNeedCover (e)
    {
        let id = '', 
            cover;
        const needCover = e.target.checked;
        
        if (!needCover)
        {
            this.props.on_select(null, 'tray_cover', false);
        }
        else if (!helper.isNotObjectOrEmpty(this.state.covers))
        {
            id = Object.keys(this.state.covers).shift();

            if (this.quantity)
            {
                cover = helper.copyObject(this.state.covers[id]);
                cover.quantity = this.quantity;

                // this.prevTrayLength = trayLength; @todo

                this.props.on_select(cover, 'tray_cover', false);
            }  /*
            cover = helper.copyObject(this.state.covers[id]);
                const trayLength = this.getTrayLength();

                if (trayLength)
                {
                    this.quantity = cover.quantity = Math.floor(trayLength / cover.length);
                    this.prevTrayLength = trayLength;

                    this.props.on_select(cover, 'tray_cover', false);
                }
            */
        }

        this.setState({id});    
    }
    setLength (e)
    {
        const cover = helper.copyObject(this.cover);

        if (this.hasTray() && !helper.isNotObjectOrEmpty(cover))
        {
            let length = e.target.value;
            
            if ('' !== length)
            {
                length = parseInt(length);

                if (isNaN(length) || length < 0)
                {
                    this.setState({alert_message: 'Некорректное значение длины крышки'});
                }
                else if (!length)
                {
                    this.setState({alert_message: 'Не задана длина крышки'});
                }
                else 
                {
                    length*=1000;

                    cover.quantity = Math.ceil(length / cover.length);

                    const roundLength = cover.length * cover.quantity;

                    if (roundLength > this.getTrayLength())
                    {
                        this.setState({alert_message: 'Длина крышки не может быть больше длины лотка'});
                    }
                    else
                    {
                        this.setState({length});

                        this.quantity = cover.quantity;
                        //console.log('setLength this.quantity', this.quantity);

                        this.props.on_select(cover, 'tray_cover', false);
                    }
                }
            }
            else
            {
                this.quantity = 0;
                this.setState({length});
            }
                
        }
    }
    roundLength ()
    {
        //console.log(this.quantity, this.cover);

        if (this.cover)
        {
            let length;
            const cover = helper.copyObject(this.cover),
                trayLength = this.getTrayLength();

            if (!this.quantity && this.hasTray())
            {
                this.quantity = cover.quantity = Math.floor(trayLength / cover.length);
                this.props.on_select(cover, 'tray_cover', false);
            }

            length = this.quantity * this.cover.length;

            this.setState({length});
        }
    } 
    componentDidMount() 
    {
        this.loadCovers();
    }
    componentDidUpdate() 
    {
        const trayLength = this.getTrayLength();

        //if (trayLength !== this.prevTrayLength) 
        if (trayLength !== this.prevTrayLength) // !this.state.length
        // компонент не монтирован с крышкой или пользователем на задана длина крышки или изменилась длина лотка
        // установим длину крышки по длине лотка
        {
            const cover = helper.copyObject(this.cover),
                hasCover = !helper.isNotObjectOrEmpty(cover);

            if (this.hasTray() && hasCover)
            {
                cover.quantity = Math.floor(trayLength / cover.length);

                if (this.quantity != cover.quantity)
                {
                    length = cover.quantity * cover.length;
                    this.quantity = cover.quantity;
                    //console.log('componentDidUpdate this.quantity', this.quantity);

                    this.setState({length});
                    this.props.on_select(cover, 'tray_cover', false);
                }
            } 

            this.prevTrayLength = trayLength;
        }        
    } 
    render() 
    {
        const needCover = !helper.isNotObjectOrEmpty(this.cover);

        let length = this.state.length ? this.state.length : '';
        if (length)
        {
            length = (length / 1000).toFixed(2)*1;
        }

        return <><Form.Group>
                    <Form.Check onChange={this.markNeedCover} onClick={this.modal.showProjectChangeWarning} checked={needCover} disabled={!this.hasTray()} type="switch" id="tray_need_cover_switch" label="Нужна крышка" />
                    {this.state.loading ? <Spinner animation="border" variant="primary" size="sm" className="ml-1" /> : ''} 
                    <div className={!needCover ? 'd-none' : 'pt-2'}>
                        <Form.Label muted={!this.hasTray()}>Длина фрагмента лотка с крышкой,&nbsp;м:</Form.Label>
                        <Form.Row>
                            <Col md={7}>                            
                                <Form.Control onChange={this.setLength} onClick={this.modal.showProjectChangeWarning} onBlur={this.roundLength} value={length} disabled={!this.hasTray()} type="text" placeholder="Длина фрагмента, м" />
                            </Col>
                            <Col md={5}>
                                <Form.Text muted>Округление до ближайшего кратного длине крышки</Form.Text>
                            </Col>
                        </Form.Row>
                    </div>
                </Form.Group>
                <AlertModal on_close={() => this.setState({alert_message: ''})} message={this.state.alert_message} /></>;
    }    
}